import * as PredictionConfigClient from '../clients/PredictionConfigClient'

export function load() {
  console.log("loading predictionConfig list")
  return new Promise ((resolve, reject) => {
    resolve(PredictionConfigClient.listPredictionConfigs())
  })
}
